import { render, staticRenderFns } from "./CreateLTLRule.vue?vue&type=template&id=3c41f8e4&scoped=true"
import script from "./CreateLTLRule.vue?vue&type=script&lang=js"
export * from "./CreateLTLRule.vue?vue&type=script&lang=js"
import style0 from "./CreateLTLRule.vue?vue&type=style&index=0&id=3c41f8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41f8e4",
  null
  
)

export default component.exports